import moment from "moment";
import Select from "react-select";
import ReactQuill from "react-quill";
import { cloneDeep } from "lodash";
import React, { Component } from "react";
import { GoUnverified } from "react-icons/go";
import { MdEdit, MdClose } from "react-icons/md";
import { BsDashCircle, BsCheck } from "react-icons/bs";
import { FiPlusCircle } from "react-icons/fi";
import TeamEdit from "./TeamEdit";
import {
  Row,
  Col,
  Label,
  Input,
  FormGroup,
  Button,
  Form,
  CustomInput,
  Card,
  CardBody,
  Tooltip,
} from "reactstrap";

import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { getAuthUser } from "../GeneralFunctions";
import * as Server from "../Server";
import config from "../config/local";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

let user = {};

class RushDataEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      camp: props.camp || {},
      minDate: "",
      maxDate: "",
      installments: 0,
      showTextBoxForInstallment: false,
      isPublicEvent: true,
      teamOptions: [],
      selectedTeam: [],
      fixedPrice: true,
      installmentDates: [],
      includeDueAmount: false,
      showCancelButton: false,
      installmentDateShow: false,
      processingFeesType: "includeProcessingFees",
      parentEvents: [],
      selectedParentEvent: {},
      useCreditAmount: false,
      addQuantity: false,
      addCode: false,
      acceptCashPayment: false,
      privacyTooltip: false,
      quantityTooltip: false,
      pastDueTooltip: false,
      creditAmountTooltip: false,
      emailFrom: "",
      emailSubject: "",
      emailHeader: "",
      teamRegistration: false,
      coupons: [],
      selectedIndexForCoupon: "",
      coupon: {},
      gotSportEventId: "",
      includeProcessingFeesTooltip: false,
      excludeProcessingFeesTooltip: false,
      showProcessingFeesTooltip: false,
    };
    this.modules = {
      toolbar: [
        [{ font: [] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
    };
    this.formats = [
      "font",
      "size",
      "bold",
      "italic",
      "underline",
      "list",
      "bullet",
      "align",
      "color",
      "background",
    ];
    this.createCamp = this.createCamp.bind(this);
    this.updateCamp = this.updateCamp.bind(this);
    this.team = [];
  }

  componentDidMount() {
    user = getAuthUser();
    this.setState((prevState) => ({
      camp: {
        ...prevState.camp,
        endingAt: this.state.camp.endingAt ? this.state.camp.endingAt : "",
      },
      includeDueAmount: prevState.camp.includeDueAmount === true ? true : false,
      useCreditAmount: prevState.camp.useCreditAmount === true ? true : false,
      showCancelButton: prevState.camp.showCancelButton === true ? true : false,
      processingFeesType:
        prevState.camp.processingFeesType || "includeProcessingFees",
      isPublicEvent: this.state.camp.campType
        ? this.state.camp.campType === "public"
        : user.connectedUser && user.connectedUser.SPIEvent
        ? true
        : false,
      fixedPrice: this.state.camp.selectedPayment
        ? this.state.camp.selectedPayment === "monthly"
          ? false
          : true
        : true,
      selectedParentEvent: prevState.camp.parentEventId
        ? {
            value: prevState.camp.parentEventId,
            label: prevState.camp.parentEventName,
          }
        : {},
      addQuantity: prevState.camp.addQuantity,
      addCode: prevState.camp.addCode,
      acceptCashPayment: prevState.camp.acceptCashPayment,
      teamRegistration: prevState.camp.teamRegistration,
      emailFrom: prevState.camp.emailSettings
        ? prevState.camp.emailSettings.emailFrom
        : "",
      emailSubject: prevState.camp.emailSettings
        ? prevState.camp.emailSettings.emailSubject
        : "",
      emailHeader: prevState.camp.emailSettings
        ? prevState.camp.emailSettings.emailHeader
        : "",
      coupons: prevState.camp.coupons ? prevState.camp.coupons : [],
      gotSportEventId: prevState.camp.gotSportEventId
        ? prevState.camp.gotSportEventId.join(",")
        : "",
    }));
    this.state.camp.installments && !this.state.camp.campType !== "public"
      ? this.setState({
          showTextBoxForInstallment: true,
          installments: this.state.camp.installments,
        })
      : this.setState({
          showTextBoxForInstallment: false,
          installments: this.state.camp.installments,
        });
    this.state.camp.installmentDates &&
      this.setState({
        installmentDates: this.state.camp.installmentDates,
        installmentDateShow:
          this.state.camp.installmentDates.length > 0 ? true : false,
      });
    this.getTeamList();
    if (user.connectedUser && user.connectedUser.SPIEvent) this.getSPIEvents();
  }

  getTeamList = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/club/teamlist",
        method: "GET",
      });
      if (response && response.teams.length) {
        let teams = [];
        response.teams.map((team) =>
          teams.push({
            label: team.name,
            value: team._id,
          })
        );
        this.setState({ teamOptions: teams });
        let selectedTeams = [];
        if (this.state.camp.teams) {
          const prefillTeams = response.teams.filter((t) =>
            this.state.camp.teams.find((r) => r === t._id)
          );
          prefillTeams.map((team) =>
            selectedTeams.push({
              label: team.name,
              value: team._id,
            })
          );
        }
        this.setState({ showLoader: false, selectedTeam: selectedTeams });
      } else {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderTeamCreatePage() {
    this.setState({ teamEditPage: true, teamEditKey: "Create-Team" });
  }

  closeTeamEditPage() {
    this.setState({
      teamEditPage: false,
    });
    this.getTeamList();
  }

  getSPIEvents = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/rushNational/camps",
        method: "GET",
      });
      if (response) {
        this.setState({
          showLoader: false,
          parentEvents: response.camps,
          selectedParentEvent: {
            value: this.state.selectedParentEvent.value
              ? this.state.selectedParentEvent.value
              : response.camps[0]._id,
            label: this.state.selectedParentEvent.value
              ? this.state.selectedParentEvent.label
              : response.camps[0].name,
          },
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  createCamp = (event) => {
    event.preventDefault();
    if (
      !this.state.isPublicEvent &&
      (!this.state.camp.teams || !this.state.camp.teams.length)
    ) {
      this.notificationSystem.addNotification({
        message: "Select the team",
        level: "error",
      });
      return;
    }
    this.setState(
      (prevState) => ({
        camp: {
          ...prevState.camp,
          installments: this.state.installments,
          selectedPayment: this.state.fixedPrice ? "fixed" : "monthly",
          campType: this.state.isPublicEvent ? "public" : "private",
          includeDueAmount: this.state.includeDueAmount,
          useCreditAmount: this.state.useCreditAmount,
          showCancelButton: this.state.showCancelButton,
          processingFeesType: this.state.processingFeesType,
          installmentDates:
            this.state.installmentDateShow === true
              ? this.state.installmentDates
              : [],
          parentEventId: this.state.selectedParentEvent.value || "",
          parentEventName: this.state.selectedParentEvent.label || "",
          addQuantity: this.state.addQuantity,
          addCode: this.state.addCode,
          acceptCashPayment: this.state.acceptCashPayment,
          teamRegistration: this.state.teamRegistration,
          emailSettings: {
            emailFrom: this.state.emailFrom,
            emailSubject: this.state.emailSubject,
            emailHeader: this.state.emailHeader,
          },
          coupons: this.state.coupons,
          gotSportEventId: this.state.gotSportEventId
            .split(",")
            .map((id) => id.trim())
            .filter((id) => id),
        },
      }),
      async () => {
        try {
          this.setState({ showLoader: true });
          let response = await Server.request({
            url: "camp/create",
            method: "POST",
            data: this.state.camp,
          });
          if (response) {
            this.setState({ showLoader: false });
            this.closeEditPage();
          }
        } catch (error) {
          this.setState({ showLoader: false });
          this.notificationSystem.addNotification({
            message: error.message,
            level: "error",
          });
        }
      }
    );
  };

  updateCamp = async (event) => {
    event.preventDefault();
    let coupon = this.state.coupons.find(
      (coupon) => coupon.price >= this.state.camp.price
    );
    if (coupon) {
      return this.notificationSystem.addNotification({
        message:
          "Discount price should not be greater than or equal to camp price",
        level: "error",
      });
    }
    await this.setState((prevState) => ({
      showLoader: true,
      camp: {
        ...prevState.camp,
        campId: prevState.camp._id,
        installments: this.state.installments,
        selectedPayment: this.state.fixedPrice ? "fixed" : "monthly",
        campType: this.state.isPublicEvent ? "public" : "private",
        includeDueAmount: this.state.includeDueAmount,
        useCreditAmount: this.state.useCreditAmount,
        showCancelButton: this.state.showCancelButton,
        processingFeesType: this.state.processingFeesType,
        installmentDates:
          this.state.installmentDateShow === true
            ? this.state.installmentDates
            : [],
        parentEventId: this.state.selectedParentEvent.value || "",
        parentEventName: this.state.selectedParentEvent.label || "",
        addQuantity: this.state.addQuantity,
        addCode: this.state.addCode,
        acceptCashPayment: this.state.acceptCashPayment,
        teamRegistration: this.state.teamRegistration,
        emailSettings: {
          emailFrom: this.state.emailFrom,
          emailSubject: this.state.emailSubject,
          emailHeader: this.state.emailHeader,
        },
        coupons: this.state.coupons,
        gotSportEventId: this.state.gotSportEventId
          .split(",")
          .map((id) => id.trim())
          .filter((id) => id),
      },
    }));
    try {
      let response = await Server.request({
        url: "camp/update",
        method: "POST",
        data: this.state.camp,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.closeEditPage();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  closeEditPage() {
    this.props.closeCampEdit();
  }

  handleTeamChange = (Teams) => {
    let teamIds = Teams.map((team) => team.value);
    this.setState((prevState) => ({
      selectedTeam: Teams,
      camp: {
        ...prevState.camp,
        teams: teamIds,
      },
    }));
  };

  installmentDates = (key) => {
    let dates =
      this.state.installmentDates.length > 0 ? this.state.installmentDates : [];
    if (key === "add") {
      if (this.state.installmentDates.length !== this.state.installments) {
        let Start =
          this.state.installmentDates.length === 0
            ? 1
            : this.state.installmentDates.length + 1;
        for (let index = Start; index <= this.state.installments; index++) {
          dates.push({ price: 0, date: "", installmentNumber: index });
        }
      }
    } else if (key === "remove") {
      for (
        let index1 = this.state.installments + 1;
        index1 <= this.state.installmentDates.length;
        index1++
      ) {
        dates = dates.filter((date) => date.installmentNumber !== index1);
      }
    }
    this.setState({ installmentDates: dates });
  };

  getCalculatedValues = (calculateValueFor, paymentUsing) => {
    let totalPrice = 0;
    let processingFees = 0;
    let netAmount = 0;
    let campPrice = Number(this.state.camp.price);
    switch (paymentUsing) {
      case "creditCard":
        switch (calculateValueFor) {
          case "processingFees":
            if (this.state.fixedPrice) {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.fullPaymentProcessingFee / 100);
            } else {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.processingFee / 100);
            }
            processingFees = totalPrice - campPrice;
            return processingFees.toFixed(2);
          case "totalPrice":
            if (this.state.fixedPrice) {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.fullPaymentProcessingFee / 100);
            } else {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.processingFee / 100);
            }
            totalPrice =
              this.state.processingFeesType === "includeProcessingFees"
                ? campPrice
                : totalPrice;
            return totalPrice.toFixed(2);
          case "netAmount":
            if (this.state.fixedPrice) {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.fullPaymentProcessingFee / 100);
            } else {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.processingFee / 100);
            }
            processingFees = totalPrice - campPrice;
            netAmount =
              this.state.processingFeesType === "includeProcessingFees"
                ? campPrice - processingFees
                : campPrice;
            return netAmount.toFixed(2);
        }
        break;
      case "bankAccount":
        switch (calculateValueFor) {
          case "processingFees":
            if (this.state.fixedPrice) {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.fullBankAccountPaymentProcessingFee / 100);
            } else {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.bankAccountProcessingFee / 100);
            }
            processingFees = totalPrice - campPrice;
            return processingFees.toFixed(2);
          case "totalPrice":
            if (this.state.fixedPrice) {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.fullBankAccountPaymentProcessingFee / 100);
            } else {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.bankAccountProcessingFee / 100);
            }
            totalPrice =
              this.state.processingFeesType === "includeProcessingFees"
                ? campPrice
                : totalPrice;
            return totalPrice.toFixed(2);
          case "netAmount":
            if (this.state.fixedPrice) {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.fullBankAccountPaymentProcessingFee / 100);
            } else {
              totalPrice =
                (campPrice + config.flatFeePerTransaction) /
                (1 - this.state.camp.bankAccountProcessingFee / 100);
            }
            processingFees = totalPrice - campPrice;
            netAmount =
              this.state.processingFeesType === "includeProcessingFees"
                ? campPrice - processingFees
                : campPrice;
            return netAmount.toFixed(2);
        }
        break;
    }
  };

  rteChange = (content, delta, source, editor) => {
    this.setState({ emailHeader: editor.getHTML() });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={this.props.campEditKey}
          breadcrumbs={[{ name: this.props.campEditKey, active: true }]}
        >
          {this.state.teamEditPage ? (
            <TeamEdit
              team={{}}
              teamEditKey={this.state.teamEditKey}
              closeTeamEditPage={() => this.closeTeamEditPage()}
            ></TeamEdit>
          ) : (
            <Card>
              <CardBody>
                <Form
                  onSubmit={
                    this.props.campEditKey === "Event-Create"
                      ? this.createCamp
                      : this.updateCamp
                  }
                >
                  {user.connectedUser && user.connectedUser.SPIEvent ? (
                    <>
                      <Row>
                        <Col sm={12} md={12} lg={6} xl={6}>
                          <FormGroup>
                            <Label>Select SPI Event :</Label>
                            <div>
                              <Select
                                options={[
                                  ...this.state.parentEvents.map((event) => ({
                                    value: event._id,
                                    label: event.name,
                                  })),
                                ]}
                                value={this.state.selectedParentEvent}
                                onChange={(result) =>
                                  this.setState({ selectedParentEvent: result })
                                }
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={6} lg={6} md={12} sm={12}>
                          <FormGroup>
                            <Label for="exampleCheckbox2">
                              Privacy
                              <GoUnverified
                                size="15px"
                                id="privacyTooltip"
                                style={{
                                  margin: "auto 5px",
                                  outline: " unset",
                                }}
                                onMouseOver={() =>
                                  this.setState({
                                    privacyTooltip: true,
                                  })
                                }
                                onMouseOut={() =>
                                  this.setState({
                                    privacyTooltip: false,
                                  })
                                }
                              />
                              <Tooltip
                                placement="bottom"
                                isOpen={this.state.privacyTooltip}
                                target="privacyTooltip"
                                toggle={() => {}}
                              >
                                Do you want this registration to only be
                                accsesable by entereing a code?
                              </Tooltip>
                              :
                            </Label>
                            <div style={{ display: "flex" }}>
                              <CustomInput
                                id="yes1"
                                type="radio"
                                label="Yes"
                                checked={this.state.addCode}
                                name="addCode"
                                onClick={(event) => {
                                  this.setState({
                                    addCode: true,
                                  });
                                }}
                              />
                              <CustomInput
                                id="no1"
                                type="radio"
                                label="No"
                                checked={!this.state.addCode}
                                name="addCode"
                                onClick={(event) => {
                                  this.setState((prevState) => ({
                                    addCode: false,
                                    camp: {
                                      ...prevState.camp,
                                      code: "",
                                    },
                                  }));
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.addCode && (
                        <Row>
                          <Col xl={6} lg={6} md={12} sm={12}>
                            <FormGroup>
                              <Label for="code">Code :</Label>
                              <Input
                                type="text"
                                name="code"
                                maxLength="4"
                                required
                                value={this.state.camp.code || ""}
                                placeholder="Code"
                                onChange={(event) => {
                                  event.persist();
                                  this.setState((prevState) => ({
                                    camp: {
                                      ...prevState.camp,
                                      code: event.target.value,
                                    },
                                  }));
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col xl={6} lg={6} md={12} sm={12}>
                          <FormGroup>
                            <Label for="exampleCheckbox3">
                              Accept Cash Payment :
                            </Label>
                            <div style={{ display: "flex" }}>
                              <CustomInput
                                id="yes2"
                                type="radio"
                                label="Yes"
                                checked={this.state.acceptCashPayment}
                                name="acceptCashPayment"
                                onClick={(event) => {
                                  this.setState({
                                    acceptCashPayment: true,
                                  });
                                }}
                              />
                              <CustomInput
                                id="no2"
                                type="radio"
                                label="No"
                                checked={!this.state.acceptCashPayment}
                                name="acceptCashPayment"
                                onClick={(event) => {
                                  this.setState((prevState) => ({
                                    acceptCashPayment: false,
                                    camp: {
                                      ...prevState.camp,
                                    },
                                  }));
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={6} lg={6} md={12} sm={12}>
                          <FormGroup>
                            <Label for="exampleCheckbox4">
                              Are you registering for Team :
                            </Label>
                            <div style={{ display: "flex" }}>
                              <CustomInput
                                id="yes3"
                                type="radio"
                                label="Yes"
                                checked={this.state.teamRegistration}
                                name="teamRegistration"
                                onClick={(event) => {
                                  this.setState({
                                    teamRegistration: true,
                                  });
                                }}
                              />
                              <CustomInput
                                id="no3"
                                type="radio"
                                label="No"
                                checked={!this.state.teamRegistration}
                                name="teamRegistration"
                                onClick={(event) => {
                                  this.setState((prevState) => ({
                                    teamRegistration: false,
                                    camp: {
                                      ...prevState.camp,
                                    },
                                  }));
                                }}
                              />
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <Col style={{ padding: 0 }}>
                      <FormGroup>
                        <Label for="exampleCheckbox">Event Type :</Label>
                        <div style={{ display: "flex" }}>
                          <CustomInput
                            id="private"
                            type="radio"
                            label="Private"
                            checked={!this.state.isPublicEvent}
                            name="eventType"
                            onClick={(event) => {
                              this.setState({
                                isPublicEvent: false,
                              });
                            }}
                          />
                          <CustomInput
                            id="public"
                            type="radio"
                            label="Public"
                            checked={this.state.isPublicEvent}
                            name="eventType"
                            onClick={(event) => {
                              this.setState({
                                isPublicEvent: true,
                              });
                            }}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  )}
                  <Row>
                    <Col xl={6} lg={6} md={12} sm={12}>
                      <FormGroup>
                        <Label for="name">Name :</Label>
                        <Input
                          type="text"
                          name="name"
                          required
                          value={this.state.camp.name || ""}
                          placeholder="Name"
                          onChange={(event) => {
                            event.persist();
                            this.setState((prevState) => ({
                              camp: {
                                ...prevState.camp,
                                name: event.target.value,
                              },
                            }));
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {!this.state.isPublicEvent && (
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Select Team :</Label>
                          <div>
                            <Select
                              isMulti
                              closeMenuOnSelect={false}
                              options={this.state.teamOptions || []}
                              value={this.state.selectedTeam}
                              onChange={this.handleTeamChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </FormGroup>
                      </Col>
                      {this.state.teamOptions.length === 0 && (
                        <Col style={{ paddingTop: 32 }}>
                          <Button
                            color="primary"
                            onClick={(event) => this.renderTeamCreatePage()}
                          >
                            Create Team
                          </Button>
                        </Col>
                      )}
                    </Row>
                  )}
                  <Row>
                    <Col sm={12} md={12} lg={6} xl={6}>
                      <FormGroup>
                        <Label for="exampleCheckbox">Select Payments :</Label>
                        <div style={{ display: "flex" }}>
                          <CustomInput
                            id="fixedPrice"
                            type="radio"
                            label="Fixed"
                            checked={this.state.fixedPrice}
                            name="fixedPrice"
                            onClick={(event) => {
                              this.setState({
                                fixedPrice: true,
                              });
                            }}
                          />
                          <CustomInput
                            id="monthlyPrice"
                            type="radio"
                            label="Monthly"
                            checked={!this.state.fixedPrice}
                            name="fixedPrice"
                            onClick={(event) => {
                              this.setState((prevState) => ({
                                camp: {
                                  ...prevState.camp,
                                  endingAt: "",
                                },
                                fixedPrice: false,
                              }));
                            }}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} md={12} lg={6} xl={6}>
                      <FormGroup>
                        <Label for="exampleCheckbox1">
                          Select Processing Fee :
                        </Label>
                        <div className="d-flex">
                          <CustomInput
                            id="include"
                            type="radio"
                            label="Exclude processing fees in price"
                            checked={
                              this.state.processingFeesType ===
                              "includeProcessingFees"
                                ? true
                                : false
                            }
                            name="processingFeesType"
                            className="ml-0"
                            onClick={(event) => {
                              this.setState({
                                processingFeesType: "includeProcessingFees",
                              });
                            }}
                          />
                          <GoUnverified
                            size="15px"
                            id="includeProcessingFeesTooltip"
                            style={{
                              margin: "auto 5px",
                              outline: " unset",
                            }}
                            onMouseOver={() =>
                              this.setState({
                                includeProcessingFeesTooltip: true,
                              })
                            }
                            onMouseOut={() =>
                              this.setState({
                                includeProcessingFeesTooltip: false,
                              })
                            }
                          />
                          <Tooltip
                            placement="bottom"
                            isOpen={this.state.includeProcessingFeesTooltip}
                            target="includeProcessingFeesTooltip"
                            toggle={() => {}}
                          >
                            This means that you the club will pay this
                            processing fee. The parent will only pay the price
                            that you have listed in this event.
                          </Tooltip>
                        </div>
                        <div className="d-flex">
                          <CustomInput
                            id="exclude"
                            type="radio"
                            label="Include processing fees in price"
                            checked={
                              this.state.processingFeesType ===
                              "excludeProcessingFees"
                                ? true
                                : false
                            }
                            name="processingFeesType"
                            onClick={(event) => {
                              this.setState({
                                processingFeesType: "excludeProcessingFees",
                              });
                            }}
                          />
                          <GoUnverified
                            size="15px"
                            id="excludeProcessingFeesTooltip"
                            style={{
                              margin: "auto 5px",
                              outline: " unset",
                            }}
                            onMouseOver={() =>
                              this.setState({
                                excludeProcessingFeesTooltip: true,
                              })
                            }
                            onMouseOut={() =>
                              this.setState({
                                excludeProcessingFeesTooltip: false,
                              })
                            }
                          />
                          <Tooltip
                            placement="bottom"
                            isOpen={this.state.excludeProcessingFeesTooltip}
                            target="excludeProcessingFeesTooltip"
                            toggle={() => {}}
                          >
                            This means that the parent will pay the processing
                            fee. The fee will be included in the toatal price.
                          </Tooltip>
                        </div>
                        <div className="d-flex">
                          <CustomInput
                            id="excludeInLine"
                            type="radio"
                            label="Show processing fees in line"
                            checked={
                              this.state.processingFeesType ===
                              "showProcessingFees"
                                ? true
                                : false
                            }
                            name="processingFeesType"
                            onClick={(event) => {
                              this.setState({
                                processingFeesType: "showProcessingFees",
                              });
                            }}
                          />
                          <GoUnverified
                            size="15px"
                            id="showProcessingFeesTooltip"
                            style={{
                              margin: "auto 5px",
                              outline: " unset",
                            }}
                            onMouseOver={() =>
                              this.setState({
                                showProcessingFeesTooltip: true,
                              })
                            }
                            onMouseOut={() =>
                              this.setState({
                                showProcessingFeesTooltip: false,
                              })
                            }
                          />
                          <Tooltip
                            placement="bottom"
                            isOpen={this.state.showProcessingFeesTooltip}
                            target="showProcessingFeesTooltip"
                            toggle={() => {}}
                          >
                            This means that the parent will pay the processing
                            fee. The fee will display as a seperate line item
                            from the total.
                          </Tooltip>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={6} lg={12} md={12} sm={12}>
                      <FormGroup>
                        <Label for="price">Price :</Label>
                        <Input
                          type="number"
                          name="price"
                          required
                          // min="0"
                          value={this.state.camp.price || ""}
                          placeholder="Price"
                          onChange={(event) => {
                            event.persist();
                            this.setState((prevState) => ({
                              camp: {
                                ...prevState.camp,
                                price: event.target.value,
                              },
                            }));
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {user.connectedUser && user.connectedUser.SPIEvent && (
                    <Col style={{ padding: 0 }}>
                      <FormGroup>
                        <Label for="exampleCheckbox1">
                          Add Multiple Registrations
                          <GoUnverified
                            size="15px"
                            id="quantityTooltip"
                            style={{
                              margin: "auto 5px",
                              outline: " unset",
                            }}
                            onMouseOver={() =>
                              this.setState({
                                quantityTooltip: true,
                              })
                            }
                            onMouseOut={() =>
                              this.setState({
                                quantityTooltip: false,
                              })
                            }
                          />
                          <Tooltip
                            placement="bottom"
                            isOpen={this.state.quantityTooltip}
                            target="quantityTooltip"
                            toggle={() => {}}
                          >
                            This gives the registrant the ability to register
                            more than one item at check out. The registration
                            price will be multiplied by the amount of
                            registrations they selected.
                          </Tooltip>
                          :
                        </Label>
                        <div style={{ display: "flex" }}>
                          <CustomInput
                            id="yes"
                            type="radio"
                            label="Yes"
                            checked={this.state.addQuantity}
                            name="quantity"
                            onClick={() =>
                              this.setState({
                                addQuantity: true,
                              })
                            }
                          />
                          <CustomInput
                            id="no"
                            type="radio"
                            label="No"
                            checked={!this.state.addQuantity}
                            name="quantity"
                            onClick={() =>
                              this.setState({
                                addQuantity: false,
                              })
                            }
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  )}
                  {
                    // !this.state.isPublicEvent &&
                    this.state.fixedPrice && (
                      <Col style={{ padding: 0 }}>
                        <FormGroup>
                          <Label for="exampleCheckbox">Select Payments :</Label>
                          <div style={{ display: "flex" }}>
                            <CustomInput
                              id="yearly"
                              type="radio"
                              label="Onetime"
                              checked={!this.state.showTextBoxForInstallment}
                              name="paymentType"
                              onClick={(event) => {
                                this.setState({
                                  installments: 0,
                                  installmentDates: [],
                                  showTextBoxForInstallment: false,
                                });
                              }}
                            />
                            <CustomInput
                              id="monthly"
                              type="radio"
                              label="Installments"
                              checked={this.state.showTextBoxForInstallment}
                              name="paymentType"
                              onClick={(event) => {
                                this.setState({
                                  showTextBoxForInstallment: true,
                                });
                              }}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )
                  }
                  {this.state.showTextBoxForInstallment &&
                  this.state.fixedPrice ? (
                    <>
                      <Row>
                        <Col xl={6} lg={6} md={12} sm={12}>
                          <FormGroup>
                            <Label for="installments">
                              Select Installments :
                            </Label>
                            <CustomInput
                              type="select"
                              id="installments"
                              name="selectInstallments"
                              defaultValue={"0"}
                              value={this.state.installments}
                              onChange={(event) => {
                                event.persist();
                                let key =
                                  event.target.value >
                                  parseInt(this.state.installments || 0)
                                    ? "add"
                                    : "remove";
                                this.setState(
                                  {
                                    installments: Number(event.target.value),
                                  },
                                  () => this.installmentDates(key)
                                );
                              }}
                            >
                              <option value="0" disabled>
                                Select the value
                              </option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                            </CustomInput>
                          </FormGroup>
                        </Col>
                      </Row>

                      {this.state.installments ? (
                        <Row>
                          <Col>
                            <div
                              className="ml-4"
                              // hidden={!this.state.installments ? true : false}
                            >
                              <Input
                                type="checkbox"
                                style={{ width: "15px", height: "15px" }}
                                checked={this.state.installmentDateShow}
                                onChange={async (event) => {
                                  this.setState(
                                    {
                                      installmentDateShow: !this.state
                                        .installmentDateShow,
                                    },
                                    () => {
                                      this.state.installmentDateShow === true &&
                                        this.installmentDates("add");
                                    }
                                  );
                                }}
                              ></Input>
                              <Label>Set Custom Installment Dates</Label>
                            </div>
                          </Col>
                        </Row>
                      ) : null}
                      {this.state.installmentDateShow && (
                        <Row>
                          <Col xl={6} lg={6} md={12} sm={12}>
                            {/* <div hidden={!this.state.installmentDateShow}> */}
                            <Label>Installment Dates :</Label>
                            {this.state.installmentDates &&
                            this.state.installmentDates.length > 0
                              ? this.state.installmentDates.map(
                                  (installmentDate, index) => (
                                    <div className="mt-2 mb-3" key={index}>
                                      {user.connectedUser &&
                                      user.connectedUser.SPIEvent ? (
                                        index === 0 ? (
                                          <Label>
                                            {" "}
                                            Initail Deposit Amount :
                                          </Label>
                                        ) : (
                                          <Label> Payment {index} :</Label>
                                        )
                                      ) : (
                                        <Label> Payment {index} :</Label>
                                      )}
                                      {index === 0 ? (
                                        <Input
                                          type="number"
                                          // min="0"
                                          required={
                                            this.state.installmentDateShow
                                          }
                                          value={installmentDate.price || ""}
                                          placeholder="Price"
                                          onChange={(event) => {
                                            // if (
                                            //   event.target.value >= 0 &&
                                            //   event.target.value <=
                                            //   this.state.camp.price
                                            // ) {
                                            let installmentDates = cloneDeep(
                                              this.state.installmentDates
                                            );
                                            installmentDates[
                                              index
                                            ].price = Number(
                                              event.target.value
                                            );
                                            this.setState({
                                              installmentDates: installmentDates,
                                            });
                                            // }
                                          }}
                                        ></Input>
                                      ) : (
                                        <Input
                                          type="date"
                                          value={
                                            moment(
                                              new Date(installmentDate.date)
                                            ).format("YYYY-MM-DD") || ""
                                          }
                                          onChange={(event) => {
                                            let dates = this.state
                                              .installmentDates;
                                            let date = new Date(
                                              event.target.value
                                            ).setUTCHours(12);
                                            dates[index].date = date;
                                            this.setState({
                                              installmentDates: dates,
                                            });
                                          }}
                                          required={
                                            this.state.installmentDateShow
                                          }
                                        ></Input>
                                      )}
                                    </div>
                                  )
                                )
                              : null}
                            {/* </div> */}
                          </Col>
                        </Row>
                      )}
                    </>
                  ) : null}
                  <Row>
                    <Col xl={4} lg={12} md={12} sm={12}>
                      <FormGroup>
                        <Label for="processingFees">
                          Processing Fees (Using Credit Card) :
                        </Label>
                        <Input
                          type="number"
                          name="processingFees"
                          disabled
                          value={this.getCalculatedValues(
                            "processingFees",
                            "creditCard"
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={4} lg={12} md={12} sm={12}>
                      <FormGroup>
                        <Label for="netAmount">
                          Net Amount (Using Credit Card) :
                        </Label>
                        <Input
                          type="number"
                          name="netAmount"
                          disabled
                          value={this.getCalculatedValues(
                            "netAmount",
                            "creditCard"
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={4} lg={12} md={12} sm={12}>
                      <FormGroup>
                        <Label for="totalPrice">
                          Total Price (Using Credit Card) :
                        </Label>
                        <Input
                          type="number"
                          name="totalPrice"
                          disabled
                          value={this.getCalculatedValues(
                            "totalPrice",
                            "creditCard"
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={4} lg={12} md={12} sm={12}>
                      <FormGroup>
                        <Label for="processingFees1">
                          Processing Fees (Using Bank Account) :
                        </Label>
                        <Input
                          type="number"
                          name="processingFees1"
                          disabled
                          value={this.getCalculatedValues(
                            "processingFees",
                            "bankAccount"
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={4} lg={12} md={12} sm={12}>
                      <FormGroup>
                        <Label for="netAmount1">
                          Net Amount (Using Bank Account) :
                        </Label>
                        <Input
                          type="number"
                          name="netAmount1"
                          disabled
                          value={this.getCalculatedValues(
                            "netAmount",
                            "bankAccount"
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={4} lg={12} md={12} sm={12}>
                      <FormGroup>
                        <Label for="totalPrice1">
                          Total Price (Using Bank Account) :
                        </Label>
                        <Input
                          type="number"
                          name="totalPrice1"
                          disabled
                          value={this.getCalculatedValues(
                            "totalPrice",
                            "bankAccount"
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={6} lg={6} md={12} sm={12}>
                      <FormGroup>
                        <Label for="startingAt">
                          {user.connectedUser && user.connectedUser.SPIEvent
                            ? "Registration Open Date"
                            : "Starting At :"}
                        </Label>
                        <Input
                          type="date"
                          name="startingAt"
                          required
                          placeholder="startingAt"
                          defaultValue={
                            moment(new Date(this.state.camp.startingAt)).format(
                              "YYYY-MM-DD"
                            ) || ""
                          }
                          onChange={(event) => {
                            event.persist();
                            this.setState((prevState) => ({
                              camp: {
                                ...prevState.camp,
                                startingAt: event.target.value,
                              },
                            }));
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {this.state.fixedPrice && (
                    <Row>
                      <Col xl={6} lg={6} md={12} sm={12}>
                        <FormGroup>
                          <Label for="endingAt">
                            {user.connectedUser && user.connectedUser.SPIEvent
                              ? "Registration Close Date"
                              : "Ending At :"}
                          </Label>
                          <Input
                            type="date"
                            name="endingAt"
                            required={this.state.fixedPrice ? true : false}
                            placeholder="endingAt"
                            defaultValue={
                              moment(new Date(this.state.camp.endingAt)).format(
                                "YYYY-MM-DD"
                              ) || ""
                            }
                            onChange={(event) => {
                              event.persist();
                              this.setState((prevState) => ({
                                camp: {
                                  ...prevState.camp,
                                  endingAt: event.target.value,
                                },
                              }));
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                  {user.connectedUser && !user.connectedUser.SPIEvent ? (
                    <Row>
                      <Col>
                        <div className="ml-4">
                          <Input
                            type="checkbox"
                            style={{ width: "15px", height: "15px" }}
                            checked={this.state.showCancelButton}
                            onChange={(event) =>
                              this.setState({
                                showCancelButton: !this.state.showCancelButton,
                              })
                            }
                          ></Input>
                          <Label>Include Cancel Button</Label>
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                  <Row>
                    <Col>
                      <div className="ml-4 mt-2">
                        <Input
                          type="checkbox"
                          style={{ width: "15px", height: "15px" }}
                          checked={this.state.includeDueAmount}
                          onChange={(event) =>
                            this.setState({
                              includeDueAmount: !this.state.includeDueAmount,
                            })
                          }
                        ></Input>
                        <Label>
                          Include Past Due
                          <GoUnverified
                            size="15px"
                            id="pastDueTooltip"
                            style={{
                              margin: "auto 5px",
                              outline: " unset",
                            }}
                            onMouseOver={() =>
                              this.setState({
                                pastDueTooltip: true,
                              })
                            }
                            onMouseOut={() =>
                              this.setState({
                                pastDueTooltip: false,
                              })
                            }
                          />
                          <Tooltip
                            placement="bottom"
                            isOpen={this.state.pastDueTooltip}
                            target="pastDueTooltip"
                            toggle={() => {}}
                          >
                            If a registrant misses a payent, this will add that
                            past due amount onto the next amount due.
                          </Tooltip>
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="ml-4 mt-2">
                        <Input
                          type="checkbox"
                          style={{ width: "15px", height: "15px" }}
                          checked={this.state.useCreditAmount}
                          onChange={(event) =>
                            this.setState({
                              useCreditAmount: !this.state.useCreditAmount,
                            })
                          }
                        ></Input>
                        <Label>
                          Use Credit Amount
                          <GoUnverified
                            size="15px"
                            id="creditAmountTooltip"
                            style={{
                              margin: "auto 5px",
                              outline: " unset",
                            }}
                            onMouseOver={() =>
                              this.setState({
                                creditAmountTooltip: true,
                              })
                            }
                            onMouseOut={() =>
                              this.setState({
                                creditAmountTooltip: false,
                              })
                            }
                          />
                          <Tooltip
                            placement="bottom"
                            isOpen={this.state.creditAmountTooltip}
                            target="creditAmountTooltip"
                            toggle={() => {}}
                          >
                            This will allow you to credit the account with any
                            value.
                          </Tooltip>
                        </Label>
                      </div>
                    </Col>
                  </Row>
                  {user.connectedUser && !user.connectedUser.SPIEvent ? (
                    <Row>
                      <Col sm={12} md={12} lg={6} xl={6}>
                        <FormGroup>
                          <Label>Got Sport Event Id :</Label>
                          <Input
                            type="text"
                            value={this.state.gotSportEventId}
                            onChange={(event) =>
                              this.setState({
                                gotSportEventId: event.target.value,
                              })
                            }
                            placeholder="Got Sport Event Id"
                          ></Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  ) : null}
                  {user.connectedUser && user.connectedUser.SPIEvent ? (
                    <>
                      <Row>
                        <Col sm={12} md={12} lg={6} xl={6}>
                          <Label>Discount Codes :</Label>
                          <FiPlusCircle
                            className="ml-2"
                            size="25px"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              let coupons = cloneDeep(this.state.coupons);
                              coupons.push({
                                code: "",
                                price: "",
                              });
                              this.setState({
                                coupons,
                                selectedIndexForCoupon:
                                  coupons.length > 0 ? coupons.length - 1 : 0,
                              });
                            }}
                          ></FiPlusCircle>
                        </Col>
                      </Row>
                      {this.state.coupons.length
                        ? this.state.coupons.map((coupon, index) => (
                            <Row key={index}>
                              <Col sm={12} md={12} lg={8} xl={8}>
                                {this.state.selectedIndexForCoupon === index ? (
                                  <Row>
                                    <Col xs={6} sm={6}>
                                      <FormGroup>
                                        <Input
                                          type="text"
                                          value={coupon.code || ""}
                                          onChange={(event) => {
                                            let coupons = cloneDeep(
                                              this.state.coupons
                                            );
                                            coupons[index].code =
                                              event.target.value;
                                            this.setState({ coupons });
                                          }}
                                        ></Input>
                                      </FormGroup>
                                    </Col>
                                    <Col xs={3} sm={3}>
                                      <FormGroup>
                                        <Input
                                          type="number"
                                          value={coupon.price || ""}
                                          onChange={(event) => {
                                            let coupons = cloneDeep(
                                              this.state.coupons
                                            );
                                            coupons[index].price =
                                              event.target.value;
                                            this.setState({ coupons });
                                          }}
                                        ></Input>
                                      </FormGroup>
                                    </Col>
                                    <Col xs={3} sm={3}>
                                      <BsCheck
                                        size="25px"
                                        style={{
                                          cursor: "pointer",
                                          margin: "0 4px",
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            selectedIndexForCoupon: "",
                                            coupon: {},
                                          });
                                        }}
                                      ></BsCheck>
                                      <MdClose
                                        size="25px"
                                        style={{
                                          cursor: "pointer",
                                          margin: "0 4px",
                                        }}
                                        onClick={() => {
                                          let coupons = cloneDeep(
                                            this.state.coupons
                                          );
                                          coupons[
                                            index
                                          ].code = this.state.coupon.code;
                                          coupons[
                                            index
                                          ].price = this.state.coupon.price;
                                          this.setState({
                                            coupons,
                                            coupon: {},
                                            selectedIndexForCoupon: "",
                                          });
                                        }}
                                      ></MdClose>
                                      <BsDashCircle
                                        size="25px"
                                        style={{
                                          cursor: "pointer",
                                          margin: "0 4px",
                                        }}
                                        onClick={() => {
                                          let coupons = cloneDeep(
                                            this.state.coupons
                                          );
                                          coupons.splice(index, 1);
                                          this.setState({ coupons });
                                        }}
                                      ></BsDashCircle>
                                    </Col>
                                  </Row>
                                ) : (
                                  <Row>
                                    <Col xs={6} sm={6}>
                                      <FormGroup>
                                        <Input
                                          type="text"
                                          disabled
                                          value={coupon.code || ""}
                                        ></Input>
                                      </FormGroup>
                                    </Col>
                                    <Col xs={3} sm={3}>
                                      <FormGroup>
                                        <Input
                                          type="number"
                                          disabled
                                          value={coupon.price || ""}
                                        ></Input>
                                      </FormGroup>
                                    </Col>
                                    <Col xs={3} sm={3}>
                                      <MdEdit
                                        size="25px"
                                        onClick={() => {
                                          this.setState({
                                            coupon: coupon,
                                            selectedIndexForCoupon: index,
                                          });
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          margin: "0 4px",
                                        }}
                                      ></MdEdit>
                                      <BsDashCircle
                                        size="25px"
                                        style={{
                                          cursor: "pointer",
                                          margin: "0 4px",
                                        }}
                                        onClick={() => {
                                          let coupons = cloneDeep(
                                            this.state.coupons
                                          );
                                          coupons.splice(index, 1);
                                          this.setState({ coupons });
                                        }}
                                      ></BsDashCircle>
                                    </Col>
                                  </Row>
                                )}
                              </Col>
                            </Row>
                          ))
                        : null}
                      <Row>
                        <Col sm={12} md={12} lg={6} xl={6}>
                          <Label>Email Settings :</Label>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} md={12} lg={6} xl={6}>
                          <FormGroup>
                            <Label>Email Subject :</Label>
                            <Input
                              type="text"
                              required
                              value={this.state.emailSubject || ""}
                              onChange={(event) =>
                                this.setState({
                                  emailSubject: event.target.value,
                                })
                              }
                              placeholder="Enter the email from"
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} md={12} lg={6} xl={6}>
                          <FormGroup>
                            <Label>Email From :</Label>
                            <Input
                              type="text"
                              required
                              value={this.state.emailFrom || ""}
                              onChange={(event) =>
                                this.setState({
                                  emailFrom: event.target.value,
                                })
                              }
                              placeholder="Text <text@text.com>"
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12} md={12} lg={6} xl={6}>
                          <FormGroup>
                            <Label>Email Header :</Label>
                            <ReactQuill
                              theme="snow"
                              value={this.state.emailHeader}
                              modules={this.modules}
                              formats={this.formats}
                              onChange={this.rteChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                  <Row>
                    <Col>
                      {this.props.campEditKey === "Camp-Create" ? (
                        <Button color="primary" type="submit">
                          Create
                        </Button>
                      ) : (
                        <Button color="primary" type="submit">
                          {this.props.campEditKey === "Event-Create"
                            ? "Create"
                            : "Update"}
                        </Button>
                      )}
                      <Button
                        className="ml-5"
                        color="secondary"
                        onClick={(event) => {
                          this.closeEditPage();
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}

export default RushDataEdit;
